import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import DatePicker from 'react-datepicker'
import { useTranslation } from 'react-i18next'

import Icon from 'components/Icon'
import DatePickerMonthSelector from 'components/Forms/Date/DatePickerMonthSelector/DatePickerMonthSelector'
import 'react-datepicker/dist/react-datepicker.css'

const ExtendedSingleDatePicker = ({
    onDateChange,
    onFocusChange,
    focused,
    date,
    disablePastDates,
    disableFutureDates,
}) => {
    const { i18n } = useTranslation()

    // Function to get weekday name
    const weekdayNames = {
        en: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
        fi: ['Su', 'Ma', 'Ti', 'Ke', 'To', 'Pe', 'La'],
    }

    const getWeekdayName = (dayString) => {
        // Map of weekday names to their indices
        const dayMap = {
            Sunday: 0,
            Monday: 1,
            Tuesday: 2,
            Wednesday: 3,
            Thursday: 4,
            Friday: 5,
            Saturday: 6,
        }

        // Get the day index from the string
        const dayIndex = dayMap[dayString]
        // Return the corresponding weekday name based on the current language
        return weekdayNames[i18n.language]?.[dayIndex]
    }

    const isOutsideRange = (moment) => {
        if (disablePastDates) return !moment.isSameOrAfter(Date.now(), 'day')
        if (disableFutureDates) return !moment.isSameOrBefore(Date.now(), 'day')
        return false
    }
    const renderCustomHeader = ({
        date,
        changeMonth,
        changeYear,
        decreaseMonth,
        increaseMonth,
        prevMonthButtonDisabled,
        nextMonthButtonDisabled,
    }) => {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <DatePickerMonthSelector
                    date={moment(date)}
                    month={moment(date)}
                    onMonthSelect={(month, newMonth) => {
                        changeMonth(newMonth)
                    }}
                    onYearSelect={(month, newYear) => {
                        changeYear(newYear)
                    }}
                    isOutsideRange={isOutsideRange}
                    disablePastDates={disablePastDates}
                    disableFutureDates={disableFutureDates}
                    decreaseMonth={decreaseMonth}
                    increaseMonth={increaseMonth}
                    prevMonthButtonDisabled={prevMonthButtonDisabled}
                    nextMonthButtonDisabled={nextMonthButtonDisabled}
                />
            </div>
        )
    }

    return (
        <DatePicker
            selected={date}
            onChange={onDateChange}
            focused={focused}
            onFocusChange={onFocusChange}
            showIcon
            icon={(
                <Icon
                    fa
                    name="calendar-alt"
                    color="#b1b1b1"
                />
            )}
            onFocus={() => {
                onFocusChange({ focused: true })
            }}
            onBlur={() => {
                onFocusChange({ focused: false })
            }}
            minDate={disablePastDates ? moment().startOf('day').toDate() : null}
            renderCustomHeader={renderCustomHeader}
            disabled={false}
            placeholder="Date"
            required={false}
            withPortal
            isOutsideRange={isOutsideRange}
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
            formatWeekDay={(date) => getWeekdayName(date)}
        />
    )
}

ExtendedSingleDatePicker.propTypes = {
    onDateChange: PropTypes.func,
    onFocusChange: PropTypes.func,
    focused: PropTypes.bool,
    date: PropTypes.instanceOf(Date),
    disablePastDates: PropTypes.bool,
    disableFutureDates: PropTypes.bool,
}

export default ExtendedSingleDatePicker
